import { render, staticRenderFns } from "./virtualAccount.vue?vue&type=template&id=7a90e73c&"
import script from "./virtualAccount.vue?vue&type=script&lang=ts&"
export * from "./virtualAccount.vue?vue&type=script&lang=ts&"
import style0 from "./virtualAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports